import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  mock: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      background: 'url(/mockup.png)',
      overflow: 'hidden',
      maxHeight: 413,
      flexGrow: 1,
      width: 949,
      marginTop: 30,
    },
  },
}));
